import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/i18n";

export default function LegalModal({ open, onClose }) {
  const { t } = useLang();
  const L = t.legal;
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="legal-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[90] bg-night/95 backdrop-blur-md flex items-center justify-center p-5"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 24 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-pine border gold-hairline px-7 sm:px-10 py-9"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="legal-modal-close"
              onClick={onClose}
              className="absolute top-5 right-6 text-bone/70 hover:text-gold font-mono text-xs uppercase tracking-[0.25em]"
              aria-label="Fermer"
            >
              ✕
            </button>
            <p className="eyebrow">{L.eyebrow}</p>
            <h2 className="font-display text-3xl sm:text-4xl font-light text-bone mt-2 mb-8">
              {L.title}
            </h2>

            <h3 className="font-display text-xl text-gold mt-6">{L.editorTitle}</h3>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.editorBody}
            </p>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.publishingDirector}
            </p>

            <h3 className="font-display text-xl text-gold mt-6">{L.hostingTitle}</h3>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.hostingBody}
            </p>

            <h3 className="font-display text-xl text-gold mt-6">{L.ipTitle}</h3>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.ipBody}
            </p>

            <h3 className="font-display text-xl text-gold mt-6">{L.creditsTitle}</h3>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.creditsOwner}
            </p>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.creditsWikimedia}{" "}
              <a
                href="https://commons.wikimedia.org/wiki/File:Baie_de_Terre_de_Haut_(les_Saintes,_Guadeloupe)_et.jpg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold underline decoration-gold/40 hover:text-goldlight"
              >
                {L.creditsWikimediaLink}
              </a>
            </p>

            <h3 className="font-display text-xl text-gold mt-6">{L.dataTitle}</h3>
            <p className="text-sm text-mist font-light leading-relaxed mt-2">
              {L.dataBody}
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
